import { TeamOutlined } from '@ant-design/icons';
import {
  CustomWarningsRule,
  InputCommonTranslationSchema,
  RequiredRule,
  tran,
  WidgetCategory,
  WidgetMainType,
  WidgetType,
  type IWidgetType,
} from '@framework/engine';
import { createElectoralListChooserFormSchema } from './createElectoralListChooserFormSchema';
import { ElectoralListChooserWidgetComponent } from './ElectoralListChooserWidgetComponent';
import {
  ElectoralListChooserWidgetConfigComponent,
  ElectoralListChooserWidgetConfigSchema,
} from './ElectoralListChooserWidgetConfigComponent';
import { ElectoralListChooserWidgetPreview } from './ElectoralListChooserWidgetPreview';
import { getElectoralListChooserReference } from './getElectoralListChooserReference';
import { getElectoralListChooserSiblingReferences } from './getElectoralListChooserSiblingReferences';
import type { IElectoralListChooserWidget } from './IElectoralListChooserWidget';

/**
 * Widget di scelta lista elettorale: selezione di una lista e di un candidato.
 * L'invio del voto è demandato al pulsante di voto (VoteWidget) presente nel form.
 */
export const ElectoralListChooserWidgetType: IWidgetType<IElectoralListChooserWidget> =
  {
    type: WidgetType.ElectoralListChooser,
    mainType: WidgetMainType.Input,
    category: WidgetCategory.Advanced,
    name: 'Scelta Lista Elettorale',
    icon: <TeamOutlined />,
    hasValue: true,
    getReference: getElectoralListChooserReference,
    getSiblingReferences: getElectoralListChooserSiblingReferences,
    formComponent: ElectoralListChooserWidgetComponent,
    createFormSchema: createElectoralListChooserFormSchema,
    previewComponent: ElectoralListChooserWidgetPreview,
    configValidator: ElectoralListChooserWidgetConfigSchema,
    configComponent: ElectoralListChooserWidgetConfigComponent,
    translationSchema: tran.widget({
      ...InputCommonTranslationSchema.objectShape,
    }),
    configOptions: {
      removeCollapsePanel: true,
      hideDirectives: true,
    },
    rules: [RequiredRule, CustomWarningsRule],
  };
